document.addEventListener('DOMContentLoaded', () => {
  const tabSections = document.querySelectorAll('.ap-tabs');

  tabSections.forEach((section) => {
    const buttons = section.querySelectorAll('[data-tab-button]');
    const panels = section.querySelectorAll('[data-tab-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.tabButton;

        buttons.forEach((btn) => {
          const isActive = btn === button;

          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive);
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === target;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });
});